export const modifierPanelSubmenu=[
    ["properties",""],
    ["propertiesBorder","deactivate"],
    ["propertiesTranform","deactivate"],
    ["propertiesText","deactivate"],
    ["propertiesMultimedia","deactivate"],
    ["otros","deactivate"],
    ["elements",""]
]
    